import { Nav } from "./Nav";
import styles from "./styles/AccountPageLayout.module.css";

export const AccountPageLayout = ({ title, children }) => {
  return (
    <main className={styles.main}>
      <h1 className={styles.title}>{title}</h1>
      <Nav />
      {children}
    </main>
  )
}
